<template>
    <v-layout row>
        <v-flex xs12>
            <v-scroll-y-transition mode="out-in">
                <v-card v-if="!checkRuap">
                  <!-- Dialogo de Ayuda -->
                    <v-card-title primary-title class="grey lighten-4">
                        <v-tooltip top>
                            <v-btn slot="activator" dark @click.stop="dialogo = true" icon class="mx-0">
                                <v-icon color="red">help</v-icon>
                            </v-btn>
                            <span>Gestionar proceso de RAP</span>
                        </v-tooltip>
                        <h3 class="headline mb-0">Mis Actuaciones</h3>
                        <v-spacer></v-spacer>
                    </v-card-title>
                  <!-- Fin del ToolTip para Dialogo de Ayuda -->

                    <v-card-title primary-title class="grey lighten-4">
                        <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div>
                            <v-data-table
                                :headers="headers"
                                :items="sat"
                                :pagination.sync="pagination"
                                :total-items="total"
                                :rows-per-page-items="rowsPerPageItems"
                                :loading="loading"
                                class="elevation-0"
                            >
                                <template v-slot:items="props">
                                    <td class="text-xs-center">{{ props.item.document_types }}</td>
                                    <td class="text-xs-center">{{ props.item.client }}</td>
                                    <td class="text-xs-center">{{ props.item.number_id }}</td>
                                    <td class="text-xs-center">{{ props.item.pages }}</td>
                                    <td class="text-xs-center">{{ Number(props.item.amount).toLocaleString('es-VE') }}</td>
                                    <td class="text-xs-center"><v-chip :color="props.item.service_status.status == 'APROBADO' ? 'green' : props.item.service_status.status == 'DEVUELTO' ? 'red' : props.item.service_status.status == 'SIN REVISAR' ? 'orange' : 'blue'" text-color="white">{{ props.item.service_status.status }}</v-chip></td>
                                    <td class="text-xs-center">{{ props.item.created_at }}</td>
                                    <td class="text-xs-center">{{ dateDiff(props) }}</td>
                                    <td class="justify-center layout px-0">
                                    <v-tooltip top v-if="props.item.service_status.status == 'APROBADO' && props.item.service_payments.length != 0">
                                        <v-btn :disabled="!props.item.service_payments[0].invoice.agreement" slot="activator" icon class="mx-0" @click="openDialogDownload(props.item)">
                                            <v-icon color="primary">cloud_download</v-icon>
                                        </v-btn>
                                        <span>Descargar</span>
                                    </v-tooltip>
                                    <v-tooltip top v-if="props.item.agreement">
                                        <v-btn @click="efectuarPago(props)" :disabled="props.item.service_payments.length != 0 ? props.item.service_payments[0].invoice.agreement : false" slot="activator" icon class="mx-0" >
                                            <v-icon color="primary">account_balance_wallet</v-icon>
                                        </v-btn>
                                        <span>Efectuar Pago</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn :disabled="props.item.agreement" @click="editItem(props.item, 'editar')" slot="activator" icon class="mx-0" >
                                            <v-icon color="blue">edit</v-icon>
                                        </v-btn>
                                        <span>Editar RAP</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn @click="editItem(props.item, 'ver')" slot="activator" icon class="mx-0" >
                                            <v-icon color="blue">description</v-icon>
                                        </v-btn>
                                        <span>Ver RAP</span>
                                    </v-tooltip>
                                    <!-- <v-tooltip top>
                                        <v-btn :disabled="props.item.agreement" @click="deleteItem(props.item)" slot="activator" icon class="mx-0" >
                                            <v-icon color="red">delete</v-icon>
                                        </v-btn>
                                        <span>Eliminar RAP</span>
                                    </v-tooltip> -->
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card-text>
                </v-card>
            </v-scroll-y-transition>
            <v-scroll-y-transition mode="out-in">
                <FormValidarActuacion v-if="checkRuap && payActivate == false" :requirements="documentsRequirementsSat" :devolutions="devolutions_list" v-on:loadingResponse="loading = $event" v-on:validarActuacion="validarActuacion($event)" v-on:closeValidate="checkRuap = false"/>
            </v-scroll-y-transition>
            <!-- <v-scroll-y-transition mode="out-in">
                <PagosRuap :information="information" v-if="payActivate" @close-loading="closeLoading" @close-pay="closePay"/>
            </v-scroll-y-transition> -->
        </v-flex>
        <v-dialog
            v-model="loading"
            hide-overlay
            persistent
            width="300"
        >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                Porfavor Espere...
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="payActivate" width="600" persistent>
            <v-flex xs12>
            <v-card>
                <v-form ref="formpago" v-model="validpago" lazy-validation>
                    <v-card-title>
                        <h3 class="headline mb-0"><span style="color: #9C1A1A">Efectuar Pago</span></h3>
                    </v-card-title>
                   <v-card-text>
                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                        ref="rif"
                                        v-model="form.rif"
                                        prepend-icon="featured_video"
                                        label="RIF"
                                        :rules="[v => !!v || 'RIF es requerido']"
                                        required
                                        mask="A-########-#"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm8>
                                    <v-text-field
                                        ref="razonsocial"
                                        v-model="form.razon_social"
                                        prepend-icon="person"
                                        label="Razon social"
                                        :rules="[v => !!v || 'Razon social es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field
                                ref="direccionfiscal"
                                v-model="form.direccion_fiscal"
                                prepend-icon="domain"
                                label="Direccion Fiscal"
                                :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 v-if="active_nc">
                            <p style="margin-left: 20px;">Usted posee un crédito por BsS: {{ new Intl.NumberFormat("de-DE").format(form.saldo_nc) }} desea usarlo? {{ form.uso_nc ? `quedan BsS ${new Intl.NumberFormat("de-DE").format(getResultNotaCredito)}` : '' }}</p>
                            <v-radio-group style="margin-left: 10px;" v-model="form.uso_nc" row>
                                <v-radio color="primary" label="SI" :value="true"></v-radio>
                                <v-radio color="primary" label="NO" :value="false"></v-radio>
                            </v-radio-group>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6 v-if="Number(getAmountTotal) > 0">
                                    <v-select
                                        prepend-icon="account_balance_wallet"
                                        :items="wayToPay"
                                        v-model="form.way_to_pay"
                                        @change="changeWayToPay"
                                        label="Método de pago"
                                        :rules="[v => !!v || 'Método de pago es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm6>
                                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                        <div class="v-input__prepend-outer">
                                        <div class="v-input__icon v-input__icon--prepend">
                                            <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                                        </div>
                                        </div>
                                        <div class="v-input__control">
                                        <div class="v-input__slot">
                                            <div class="v-text-field__slot">
                                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto a pagar</label>
                                            <vue-numeric read-only currency="BsS" :value="Number(getAmountTotal)" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                            </div>
                                        </div>
                                        <div class="v-text-field__details">
                                            <div class="v-messages theme--light">
                                            <div class="v-messages__wrapper">
                                                Precio con IVA incluido
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12 v-if="Number(getAmountTotal) > 0">
                            <v-select
                                v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                prepend-icon="account_balance"
                                :items="banks"
                                v-model="form.bank_id"
                                item-text="name"
                                item-value="id"
                                label="Banco"
                                :rules="[v => !!v || 'Banco de pago es requerido']"
                                required
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between v-if="Number(getAmountTotal) > 0">
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                        ref="number"
                                        v-model="form.number"
                                        prepend-icon="remove"
                                        label="Número de transacción"
                                        mask="###############"
                                        :rules="[v => !!v || 'Número de transacción es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-menu
                                        ref="menu"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        :return-value.sync="date"
                                    >
                                        <v-text-field
                                        slot="activator"
                                        label="Fecha"
                                        v-model="computedDateFormattedFecha"
                                        hint="DD/MM/YYYY formato"
                                        prepend-icon="event"
                                        :rules="[v => !!v || 'Fecha es requerido']"
                                        required
                                        readonly
                                        ></v-text-field>
                                        <v-date-picker v-model="form.payment_date" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-flex>
<!-- 
                        <v-flex xs12>
                            <v-textarea
                                prepend-icon="reorder"
                                v-model="form.observations"
                                auto-grow
                                color="primary"
                                label="Observación"
                                rows="2"
                            ></v-textarea>
                        </v-flex> -->

                        <v-flex xs12 v-if="Number(getAmountTotal) > 0">
                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                            <v-text-field
                                :rules="[v => !!v || 'Comprobante de pago es requerido']"
                                ref="document"
                                v-model="nameImg"
                                @click.native="onFocus"
                                prepend-icon="attach_file"
                                label="Comprobante de pago"
                            ></v-text-field>
                        </v-flex>

                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="closePay">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :loading="loading" color="primary" @click="confirmData">Confirmar Pago</v-btn>
                </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
        </v-dialog>

        <v-dialog v-model="dialogDownload" width="600" persistent>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        <h3 class="headline mb-0"><span style="color: #9C1A1A">Descargas</span></h3>
                    </v-card-title>
                    <v-card-text>
                        <!-- <v-radio-group v-model="radioGroup">
                            <v-radio
                                color="primary"
                                label="Documentos con Troquel"
                                value="1"
                            ></v-radio>
                            <v-radio
                                color="primary"
                                label="Hoja Blanca con Troquel"
                                value="2"
                            ></v-radio>
                            <v-btn v-if="radioGroup == 2" color="primary" @click="downloadDocuments(radioGroup,null)">Descargar</v-btn>
                        </v-radio-group> -->
                    <!-- <v-radio-group v-model="radioGroupUbicacion">
                        <v-radio
                            color="primary"
                            label="Troquel en Esquina Superior Derecha"
                            value="D"
                        ></v-radio>
                        <v-radio
                            color="primary"
                            label="Troquel en Esquina Superior Izquierda"
                            value="I"
                        ></v-radio>
                    </v-radio-group> -->

                     <v-list pa-0 ma-0 subheader three-line v-if="radioGroup == 1">
                      <v-list-tile pa-0 ma-0 v-for="(document1,i) in infoDownload.document_requiremets" :key="i" style="height: 40px">
                        <v-list-tile-action>
                          <v-container fluid>
                            <p v-if="!document1.document_data.required" class="caption">ACTUACION: {{ document1.document_data.description }}</p>
                          </v-container>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <p v-if="document1.document_data.required" class="caption">{{ document1.document_data.description }} <a v-if="document1.document_data.required" @click="downloadDocuments(radioGroup,document1.id)">{{ document1.src == null ? '' : 'Descargar' }}</a> </p>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>

                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="dialogDownload = false">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-dialog>

        <v-dialog v-model="dialogEditar" width="800" persistent>
            <v-flex xs12 v-if="dialogEditar">
                <FormEditarActuacion :requirements="documentsRequirementsSat" :loading="loading" :tipo="tipo" :datos="form2" v-on:loadingResponse="loading = $event" v-on:closeEditar="closeEditar" v-on:updateActuacionResponse="updateActuacionResponse()" v-on:updateActuacionResponseValidate="updateActuacionResponseValidate($event)"/>
            </v-flex>
        </v-dialog>

        <v-dialog v-model="dialogo" max-width="600">
          <v-card>
            <v-card-title class="headline">Seguimiento y Control</v-card-title>
            <v-card-text>
              Liste todas las actuaciones profesionales que ha registrado para gestionarlas.
              <br>
              <ul>
                <li>
                  Haciendo un seguimiento en tiempo real de todo el proceso de  protección.
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" @click="dialogo = false">
                Salir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

  </v-layout>
</template>

<script>
import moment from 'moment';
import Form from 'vform'
import axios from 'axios'
import VueNumeric from 'vue-numeric'
import { mapGetters } from 'vuex'
import PagosRuap from '~/components/pagos/pay.vue'
import FacturaPago from '~/components/factura/FacturaPago.vue'
import FormValidarActuacion from '~/pages/cliente/FormValidarActuacion.vue'
import FormEditarActuacion from '~/pages/cliente/FormEditarActuacion.vue'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    name: "sat-view",

    components: {
        FormEditarActuacion,
        FormValidarActuacion,
        FacturaPago,
        PagosRuap,
        VueNumeric
    },

    computed: {
        ...mapGetters({
            documentsRequirementsSat: 'getDocumentRequirementSat',
            documentsRequirementsChildSat: 'getSatDocumentsTypeChild',
            documentsType: 'getSatDocumentsType',
            banks: 'getSatBanks',
            user: 'getSatStatusUser',
            received: 'getSatRuapReceived',
            document_price: 'getSatDocumentPrice',
            devolutions_list: 'getSatDevolutionsList',
            electronic_points: 'getSatElectronicPoints',
            print: 'printFacturaPay',
            dataFactura: 'dataFacturaPay'
        }),
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        },
        computedDateFormattedFecha2 () {
            return this.formatDate(this.formConciliacion.payment_date)
        },
        getResultNotaCredito () {
            let saldo_nc = parseFloat(this.form.saldo_nc)
            let monto_total = parseFloat(this.price)
            let monto_total_result = 0
            monto_total_result = parseFloat(saldo_nc - monto_total).toFixedDown(2)

            if (this.form.uso_nc) {
                if(monto_total_result < 0){
                    monto_total = 0
                }else {
                    monto_total = monto_total_result
                }
            }else {
                monto_total = saldo_nc
            }

            return monto_total
        },
        getAmountTotal () {
            let saldo_nc = parseFloat(this.form.saldo_nc)
            let monto_total = parseFloat(this.price).toFixedDown(2)
            let monto_total_result = 0

            if (this.form.uso_nc) {
                monto_total_result = parseFloat(monto_total - this.form.saldo_nc).toFixedDown(2)
                if(monto_total_result < 0){
                    monto_total = 0
                }else {
                    monto_total = monto_total_result
                }
            }

            this.form.amount = monto_total

            return monto_total
        }
    },

    data () {
      return {
        tipo: '',
        active_nc: false,
        radioGroup: '1',
        radioGroupUbicacion: 'D',
        date: null,
        fecha: null,
        menu: false,
        fecha2: null,
        menu2: false,
        sat: [],
        information: {},
        infoDownload: {},
        search: '',
        total: 0,
        price: 0,
        valid: false,
        validpago: false,
        validConciliacion: false,
        dialog: false,
        dialogo: false,
        dialogDownload: false,
        dialogEditar: false,
        loading: false,
        checkRuap: false,
        payActivate: false,
        dialogConsolidacion: false,
        editedIndex: -1,
        datos: {},
        pagination: {},
        wayToPay: ['TRANSFERENCIA'],
        nameImg: '',
        taxes: 16,
        form: new Form({
            cpc: '',
            saldo_nc: 0,
            way_to_pay: 'TRANSFERENCIA',
            number: null,
            ruap_id: null,
            payment_date: '',
            observations: '',
            rif: '',
            file: '',
            document: '',
            razon_social: '',
            direccion_fiscal: '',
            agreement: false,
            uso_nc: false,
            concept_document_type_id: null
        }),
        form2: new Form({
            id: '',
            cpc: '',
            document_type: '',
            document_types: '',
            document_requiremets: '',
            client: '',
            number_id: '',
            subject: '',
            date: '',
            pages: '',
            observation: '',
            tipo_hoja: '',
            tipo_persona: '',
            security_papers: null,
            amount: '',
            cantidad: null,
            concept_document_type_id: null
        }),
        headers: [
          { text: 'Tipo Documento', align: 'center',value: 'document_types', sortable: false },
          { text: 'Cliente', align: 'center' , value: 'client', sortable: false },
          { text: 'Cedula o Rif', align: 'center' , value: 'number_id', sortable: false },
          { text: 'Paginas', align: 'center' , value: 'pages', sortable: false },
          { text: 'Monto', align: 'center' , value: 'amount', sortable: false },
          { text: 'Estatus', align: 'center' , value: 'status', sortable: false },
          { text: 'Fecha', align: 'center' , value: 'created_at', sortable: false },
          { text: 'Respuesta', align: 'center' , value: 'updated_at', sortable: false },
          { text: 'Acciones', align: 'center', sortable: false }
        ],
        rowsPerPageItems: [5, 10, 20, 50, 100]
      }
    },

    watch: {

        pagination() {
            this.getSatByPagination();
        },

        received(v) {
            if (v.length !== 0) {
                // console.log(v.length,'tamano')
                this.search = v.data[0].client;
                this.sat = v.data;
                this.total = v.total;
            }
        }

    },

    mounted () {
        this.$store.dispatch('clearMessage')
        this.$store.dispatch('fetchSatDocumentsType')
    },

    methods: {

        dateDiff (props) {
            if (props.item.updated_at == null) {
                return ''
            } else {
                let a = moment(props.item.created_at)
                let b = moment(props.item.updated_at)
                var diff = moment.duration(moment(b).diff(moment(a)));

                return parseInt(diff.asDays()) + ' dias ' + moment.utc(moment(props.item.updated_at, "YYYY/MM/DD HH:mm:ss").diff(moment(props.item.created_at, "YYYY/MM/DD HH:mm:ss"))).format("HH:mm:ss")
            }
        },

        openDialogDownload(item) {
            this.infoDownload = item
            this.dialogDownload = true
        },

        async downloadDocuments(tipo,id_document) {
            let id_ruap = this.infoDownload.id
            window.open(`/api/cliente/download-documents/${tipo}/${id_ruap}/${id_document}/${this.radioGroupUbicacion}`);
            // this.loading = true
            // let id_ruap = this.infoDownload.id
            // await axios({
            //         url: `/api/cliente/download-documents/${tipo}/${id_ruap}/${id_document}`,
            //         method: 'GET',
            //         responseType: 'blob', // important
            //     }).then(resp => {
            //     const blob = new Blob([resp.data], {type: resp.data.type});
            //     const url = window.URL.createObjectURL(blob);
            //     const link = document.createElement('a');
            //     link.href = url;
            //     const contentDisposition = resp.headers['content-disposition'];
            //     let fileName = 'unknown';
            //     if (contentDisposition) {
            //         const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            //         if (fileNameMatch.length === 2)
            //             fileName = fileNameMatch[1];
            //     }
            //     link.setAttribute('download', fileName);
            //     document.body.appendChild(link);
            //     link.click();
            //     link.remove();
            //     window.URL.revokeObjectURL(url);
            // }).catch(error => {
            //     console.log(error.response)
            //     this.$store.dispatch('responseMessage', {
            //         type: 'error',
            //         text: 'Error, Intente descargar nuevamente'
            //     })
            // }).finally(() => this.loading = false);
        },

        revisionUnionizeCheck (response) {
            let result = false
            let bad = 0
            let esto = this
            response.document_requiremets.forEach(function(element) {
                if(element.document_data.required){
                    if(element.unionize_check == false || element.unionize_check == null){
                        bad++
                    }
                }else{
                    esto.form.id_padre = element.id
                }
            });

            result = bad == 0 ? false : true

            return result
        },

        getSatByPagination() {
            this.loading = true;
            if (this.search) {
                axios.get(`/api/cliente/ap-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                axios.get(`/api/cliente/ap-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                axios.get(`/api/cliente/ap?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.sat = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async confirmData () {
            if (this.$refs.formpago.validate()) {
                this.loading = true
                this.form.agreement = confirm('Esta Seguro de procesar el pago?')
                    if(this.form.agreement){
                        let formData = new FormData();
                        for (var key in this.form) {
                            formData.append(key, this.form[key]);
                        }
                        await axios.post(`/api/cliente/ap-pay`,formData)
                            .then(res => {
                                this.$store.dispatch('responseMessage', {
                                    type: 'success',
                                    text: 'Carga de pago Exitosa!..'
                                })
                                this.closePay()
                            })
                            .catch(error => {
                                console.log(error.response)
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: 'Error, Intente mas Tarde'
                                })
                            })
                    }
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        editItem (item, tipo) {
            this.tipo = tipo
            this.editedIndex = this.sat.indexOf(item)
            this.form2 = Object.assign({}, item)
            this.form2.concept_document_type_id = item.concept_document_type_id
            if(item.security_papers == "null" || item.security_papers == null){
                this.form2.security_papers = null
            }
            this.dialogEditar = true
        },

        async deleteItem (item) {
            let response = confirm('Estas seguro de eliminar este RAP?')
            if(response){
                this.loading = true
                await this.$store.dispatch('deleteRap', item.id)
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        onChange () {
            this.getSatByPagination();
        },

        async changeWayToPay() {
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        async submitFormUpdate() {
            if (this.$refs.formnewruap.validate()) {
                this.loading = true
                this.form.amount = this.document_price
                await this.$store.dispatch('submitUpdateRuap', this.form)
                this.$nextTick(() => {
                    this.dialog = false
                    this.loading = false
                    this.nameImg = ''
                    this.form = {
                        cpc: '',
                        document_type: '',
                        client: '',
                        number_id: '',
                        subject: '',
                        date: '',
                        file: '',
                        pages: '',
                        amount: ''
                    }
                    this.$refs.formnewruap.resetValidation()
                })
            }
        },

        async closeRegisterSat() {
            this.dialog = false
            this.nameImg = ''
            this.form = {
                cpc: '',
                document_type: '',
                client: '',
                number_id: '',
                subject: '',
                date: '',
                file: '',
                pages: '',
                amount: ''
            }
            await this.validCpcRuap()
            this.loading = false
            this.$refs.formnewruap.resetValidation()
        },

        async checkSat (props) {
            this.loading = true
            this.checkRuap = true
            await this.$store.dispatch('searchDocumentRuapRequirement', props.item.id)
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async efectuarPago(props) {
            this.loading = true
            await axios.get(`/api/cliente/getTaxForRape/${props.item.concept_document_type_id}/${props.item.id}`).then(resp => {
                console.log(resp.data)
                this.active_nc = resp.data.active_nc
                this.price = resp.data.amount_dt,
                this.form = {
                    cpc: props.item.cpc,
                    amount: resp.data.amount_dt,
                    saldo_nc: resp.data.saldo_nc,
                    uso_nc: false,
                    razon_social: props.item.client,
                    ruap_id: props.item.id,
                    way_to_pay: 'TRANSFERENCIA',
                    rif: props.item.number_id,
                    concept_document_type_id: props.item.concept_document_type_id,
                }
                this.$refs.formpago.resetValidation()
                this.payActivate = true
            }).catch(err => {
                console.log(err.response.data, 'error')
                this.$refs.formpago.resetValidation()
                this.payActivate = false
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Error Servidor, Intente su pago mas tarde.'
                })
            }).finally(() => this.loading = false)
        },

        async closeLoading() {
            this.loading = false;
        },

        async closePay() {
            this.nameImg = ''
            this.form = {
                cpc: '',
                way_to_pay: 'TRANSFERENCIA',
                number: null,
                ruap_id: null,
                payment_date: '',
                observations: '',
                rif: '',
                file: '',
                razon_social: '',
                direccion_fiscal: '',
                agreement: false
            }
            this.payActivate = false
        },

        onFocus() {
            this.nameImg = ''
            this.$refs.fileInput.value = ''
            this.$refs.fileInput.click()
        },

        processFile(event) {
            let files = event.target.files || event.dataTransfer.files
            if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "application/pdf") {
                this.form.file = files[0]
                this.nameImg = files[0].name
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'El formato del documento debe ser PNG/JPG/JPEG o PDF'
                })
            }
        },

        async updateActuacionResponse(){
            this.dialogEditar = false
            this.getSatByPagination()
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async updateActuacionResponseValidate(data){
            this.dialogEditar = false
            this.checkRuap = true
            await this.$store.dispatch('searchDocumentRuapRequirement', data.id)
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async validarActuacion(datos) {
            this.checkRuap = datos
            this.getSatByPagination()
        },

        closeEditar () {
            this.dialogEditar = false
            this.$nextTick(() => {
                this.loading = false
            })
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/MisActuaciones.vue